/* eslint-disable import/no-cycle */
/* eslint-disable react/no-danger */
import React from 'react';
import IllnessJPG from '@assets/images/illness.jpg';
import IllnessMobileJPG from '@assets/images/illness-mobile.jpg';
import { ContainerSmall } from '~/utils/styles/utils';
import HeaderFooterLayout from '~/components/molecules/HeaderFooterLayout/HeaderFooterLayout';
import { useTranslationContext } from '~/pages/schlaganfall-therapie-muenchen';
import { useTranslationContext as useTranslationContextEn } from '~/pages/en/stroke-therapy-munich';

const StrokePage: React.FC = () => {
  const t = useTranslationContext();
  const tEn = useTranslationContextEn();

  return (
    <>
      <HeaderFooterLayout
        desktopHero={IllnessJPG}
        mobileHero={IllnessMobileJPG}
        altHero="Modell eines Gehirns zur Krankheitserklärung von Schlaganfall."
        enLink="/en/stroke-therapy-munich/"
        deLink="/schlaganfall-therapie-muenchen/"
      >
        <ContainerSmall>
          <div
            dangerouslySetInnerHTML={{
              __html: t('StrokeContent1') || tEn('StrokeContent1'),
            }}
          />
          <div
            dangerouslySetInnerHTML={{
              __html: t('StrokeContent2') || tEn('StrokeContent2'),
            }}
          />
        </ContainerSmall>
      </HeaderFooterLayout>
    </>
  );
};

export default StrokePage;
